import { defineComponent as _defineComponent } from 'vue'
import { MAP_POINT_PATH } from './WheelsTripMap.constants'

export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsTripMapPoint',
  setup(__props) {


return { __sfc: true,MAP_POINT_PATH }
}

})